import { render, staticRenderFns } from "./HeaderSearchBox.vue?vue&type=template&id=60b5c671&scoped=true&"
import script from "./HeaderSearchBox.vue?vue&type=script&lang=js&"
export * from "./HeaderSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSearchBox.vue?vue&type=style&index=0&id=60b5c671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5c671",
  null
  
)

export default component.exports